import { useEffect, useState } from 'react';
import { supplierMap } from '@adac-mp/shared/src/constants/supplierMap';

export const useFlowId = (): number | null => {
	const [flowId, setFlowId] = useState<string | null>(null);
	useEffect(() => {
		const currFlowId = sessionStorage.getItem('flowId');
		const isValidId = Object.keys(supplierMap).some((id) => id === currFlowId);
		if (isValidId) {
			setFlowId(currFlowId);
		}
	}, []);
	return flowId ? Number(flowId) : null;
};
